import { motion } from "framer-motion";
import { Quote } from "lucide-react";

/**
 * Signed Cesar Millan endorsement card — floats on the hero.
 */
export default function CesarTestimonial({ testid = "cesar-testimonial" }) {
  return (
    <motion.aside
      data-testid={testid}
      initial={{ opacity: 0, y: 24, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: 1.4, duration: 1, ease: [0.19, 1, 0.22, 1] }}
      className="hidden lg:flex absolute right-8 top-1/2 -translate-y-1/2 z-20 max-w-sm glass-strong rounded-2xl p-6 flex-col gap-4 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.6)]"
    >
      <div className="flex items-center gap-3">
        <Quote className="text-[color:var(--wk-gold)]" size={18} />
        <div className="overline text-[10px]">Endorsement</div>
      </div>
      <p className="font-serif-display italic text-xl leading-snug text-[color:var(--wk-bone)]">
        "Toriano is one of the finest students I have ever trained. He carries the work forward
        with humility, science, and heart — and now, he leads."
      </p>
      <div className="flex items-center gap-3 pt-3 border-t border-white/10">
        <div className="flex-1">
          <div className="text-sm text-[color:var(--wk-bone)]">Cesar Millan</div>
          <div className="text-xs text-[color:var(--wk-bone-dim)]">The Dog Psychology Center</div>
        </div>
        <svg
          viewBox="0 0 200 60"
          className="h-10 w-auto text-[color:var(--wk-gold)]"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <path d="M8 42 C 22 12, 38 12, 46 40 S 66 20, 78 34 C 92 44, 108 8, 128 34 S 156 46, 172 22" />
          <path d="M96 46 L 190 46" opacity="0.55" />
        </svg>
      </div>
    </motion.aside>
  );
}
